module.exports = __webpack_public_path__ + "img/专利有效数.936612eb.png";